<div class="delivery-past-events-view-part">
	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="pastEvents()"></grid-content>
</div>